// redux/slices/blogCategorySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

// 🔥 GET ALL
export const fetchCategories = createAsyncThunk(
  "blogCategory/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get(`/blog-category/categories`);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

// 🔥 CREATE
export const createCategory = createAsyncThunk(
  "blogCategory/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await api.post(`/blog-category/create-category`, data);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

// 🔥 UPDATE
export const updateCategory = createAsyncThunk(
  "blogCategory/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await api.put(`/blog-category/update/category/${id}`, data);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

// 🔥 DELETE
export const deleteCategory = createAsyncThunk(
  "blogCategory/delete",
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`/blog-category/delete/category/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

const blogCategorySlice = createSlice({
  name: "blogCategory",
  initialState: {
    categories: [],
    loading: false,
    error: null
  },
  reducers: {},

  extraReducers: (builder) => {
    builder

      // ✅ FETCH
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ✅ CREATE
      .addCase(createCategory.fulfilled, (state, action) => {
        state.categories.unshift(action.payload);
      })

      // ✅ UPDATE
      .addCase(updateCategory.fulfilled, (state, action) => {
        const index = state.categories.findIndex(
          (c) => c.categoryId === action.payload.categoryId
        );
        if (index !== -1) {
          state.categories[index] = action.payload;
        }
      })

      // ✅ DELETE
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.categories = state.categories.filter(
          (c) => c.categoryId !== action.payload
        );
      });
  }
});

export default blogCategorySlice.reducer;